import React from "react";
import { Box, Radio as ChakraRadio } from "@chakra-ui/react";
export function Radio({ isDisabled, label, description, value }) {
    return (React.createElement(Box, null,
        React.createElement(ChakraRadio, { isDisabled: isDisabled, value: value }, label),
        description && (React.createElement(Box, { pl: 7, fontSize: "md", color: "gray.600", lineHeight: "tall" }, description))));
}
